import { ISupportTicketState } from '../state/ISupportTicketState';
import * as actions from '../actions/';

export const initialState: ISupportTicketState = {
  supportTicketInformation: undefined
}

export function supportTicketReducer(state = initialState, action: actions.Actions ) {
  switch (action.type) {
    case actions.GET_SUPPORT_TICKET_INFORMATION_SUCCESS_ACTION:
      var model = (action as actions.GetSupportTicketInformationSuccessAction).payload.supportTicketInformation;
      return {
        ...state,
        supportTicketInformation: model
      };
    case actions.ACTIVATE_DRAFT_MESSAGE_TO_USERS_SUCCESS_ACTION:
      var newActiveMessageToUsers = (action as actions.ActivateDraftMessageToUsersSuccessAction).payload.activatedMessageToUsers;
      return {
        ...state,
        supportTicketInformation: {
          ...state.supportTicketInformation,
          draftMessageToUsersDescription: "",
          activeMessageToUsersDescription: newActiveMessageToUsers
        }
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/security/store/reducers/support-ticket.reducer.ts